import { useState, useEffect } from 'react';
import { usersService, User, entitlementsService } from '../services/firebaseFunctions';

export const useUsers = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Carregar usuários
  const loadUsers = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await usersService.getAll();
      setUsers(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar usuários');
    } finally {
      setLoading(false);
    }
  };

  // Buscar entitlements do usuário
  const getUserEntitlements = async (userId: string) => {
    try {
      const entitlements = await entitlementsService.getUserEntitlements(userId);
      return entitlements;
    } catch (err) {
      throw new Error(err instanceof Error ? err.message : 'Erro ao buscar entitlements do usuário');
    }
  };

  // Carregar usuários na inicialização
  useEffect(() => {
    loadUsers();
  }, []);

  return {
    users,
    loading,
    error,
    getUserEntitlements,
    loadUsers,
  };
};
